module.exports = __webpack_public_path__ + "857fcbd4563d45f494665ae4a76d3b3d.png";